module.exports = __webpack_public_path__ + "static/img/holidayCol.990cd5b0.svg";